function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import SideBySideTextAndAssetDefaultProps from "segments/desktop/core-components/side-by-side-text-and-asset/default-props";
import { SIGNUP_BUTTON_TYPE } from "segments/desktop/core-components/button/button-consts";
import { MD } from "constants/sizes";
const getFullParagraph = ()=>{
    const { fullParagraph } = SideBySideTextAndAssetDefaultProps;
    return _object_spread_props(_object_spread({}, fullParagraph), {
        title: "<monday-color green>Together.</monday-color> In projects, processes, and success. Wherever you are.",
        body: "monday.com is the Work OS that powers teams to run projects and workflows with confidence.",
        topic: {},
        buttonConfig: {
            buttonType: SIGNUP_BUTTON_TYPE,
            buttonColor: "dodger-blue"
        }
    });
};
const getAssetDefaultProps = ()=>{
    const { asset } = SideBySideTextAndAssetDefaultProps;
    const { image } = asset;
    const newImage = _object_spread_props(_object_spread({}, image), {
        src: "/static/img/segment-layout-default-images/first-fold/globe2.png"
    });
    return _object_spread_props(_object_spread({}, asset), {
        image: newImage
    });
};
export default {
    fullParagraph: getFullParagraph(),
    asset: getAssetDefaultProps(),
    titleSize: MD
};
